import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import videoFilePoster from '../../assets/movie.jpg';
import videoFile from '../../assets/movie.mp4';
import SpeakerOff from '../../assets/speaker_off.png';
import SpeakerOn from '../../assets/speaker_on.png';
import { VerticalLayout } from '../../common/common-layout';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useDeviceType } from '../../hooks/useDeviceType';
// 아이콘 파일 직접 추가하거나, 아래처럼 임시로 텍스트 사용 가능

type VisionSection4Props = {
  isInView: boolean;
};

const VisionSection4 = ({ isInView }: VisionSection4Props) => {
  const { isMobile } = useDeviceType();
  const { trackVideoPlay } = useAnalytics();
  const videoRef = useRef<HTMLVideoElement>(null);
  const [imageAnimated, setImageAnimated] = useState(false);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    if (isInView && !imageAnimated) {
      setImageAnimated(true);
    }
  }, [isInView, imageAnimated]);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <VerticalLayout
      style={{
        background: 'white',
        height: isMobile ? 'auto' : '100vh',
        width: '100vw',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <motion.div
        initial={{ scale: 0.5 }}
        animate={isInView ? { scale: 1 } : {}}
        transition={{ duration: isInView ? 0.8 : 0.0, ease: 'easeInOut' }}
        style={{
          width: '100%',
          height: isMobile ? 'auto' : '100%',
        }}
      >
        <video
          ref={videoRef}
          autoPlay
          loop
          muted={isMuted}
          playsInline
          onPlay={() => trackVideoPlay('경영비전', 'vision', 0)}
          poster={videoFilePoster}
          style={{
            width: '100%',
            height: isMobile ? 'auto' : '100%',
            objectFit: 'cover',
          }}
        >
          <source src={videoFile} type="video/mp4" />
          브라우저가 video 태그를 지원하지 않습니다.
        </video>
      </motion.div>

      {/* 음소거 토글 버튼 */}
      <img
        src={isMuted ? SpeakerOff : SpeakerOn}
        alt="Speaker icon"
        onClick={toggleMute}
        style={{
          position: 'absolute',
          bottom: '24px',
          right: '24px',
          width: `${pxToRem(80)}`,
          height: `${pxToRem(80)}`,
          objectFit: 'contain',
          cursor: 'pointer',
          transition: 'transform 0.1s ease',
        }}
        onMouseDown={(e) => {
          e.currentTarget.style.transform = 'scale(0.9)';
        }}
        onMouseUp={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
        }}
      />

    </VerticalLayout>
  );
};

export default VisionSection4;
